// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { MatchHotBetGroupOutcomeContext } from '../../contexts/MatchHotBetGroupOutcomeContext';
import useMatchViewContext from '../../hooks/useMatchViewContext';
import useMergeProps from '../../hooks/useMergeProps';

import MatchHotBetGroupOutcome from './MatchHotBetGroupOutcome';
import makeMatchHotBetGroupOutcomePropsSelector from './MatchHotBetGroupOutcome.selector';

type MatchHotBetGroupOutcomeContainerProps = {
  className?: string;
  outcomeId: number;
  betId: number;
  isMultichoice: boolean;
};

const MatchHotBetGroupOutcomeContainer = ({
  outcomeId,
  betId,
  isMultichoice,
  ...ownProps
}: MatchHotBetGroupOutcomeContainerProps) => {
  const { matchId } = useMatchViewContext();

  const selectorProps = useMemo(
    () => ({ betId, outcomeId, isMultichoice, matchId }),
    [betId, outcomeId, isMultichoice, matchId],
  );
  const selector = useMemo(() => makeMatchHotBetGroupOutcomePropsSelector(), []);
  const selectedProps = useSelector((state) => selector(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  const forwardedState = useMemo(() => ({ outcomeId, betId, isMultichoice }), [outcomeId, betId, isMultichoice]);

  return (
    <MatchHotBetGroupOutcomeContext.Provider value={forwardedState}>
      <MatchHotBetGroupOutcome {...enhancedProps} />
    </MatchHotBetGroupOutcomeContext.Provider>
  );
};

export default MatchHotBetGroupOutcomeContainer;
